<script setup>
import { useStore } from "vuex";
import { useCarbonImpactTotals } from "@/composables/useCarbonImpactTotals";

const store = useStore();
const {
  items,
  totalArea,
  totalVolume,
  totalMass,
  totalFootprint,
} = useCarbonImpactTotals({ store });

defineExpose({
  totalArea,
  totalVolume,
  totalMass,
  totalFootprint
});

function roundToFixed2(number) {
  return (Math.round(number * 100) / 100).toFixed(2);
}

</script>

<template>
  <h3 class="schedule-table-title">{{ $t('components.scheduleDataTable.tableTitle') }}</h3>
  <v-table height="600px" fixed-header fixed-footer>
    <thead>
      <tr>
        <th>
          {{ $t('name').capitalize() }}<br />
          {{ $t('total').capitalize() }}:
        </th>
        <th>
          <span v-html="`${$t('area').capitalize()} (${$t('measuringUnits.inch')}${$t('square')})`"></span><br />
          {{ roundToFixed2(Number(totalArea)) }}
        </th>
        <th>
          <span v-html="`${$t('volume').capitalize()} (${$t('measuringUnits.inch')}${$t('cube')})`"></span><br />
          {{ roundToFixed2(Number(totalVolume)) }}
        </th>
        <th>
          {{ $t('mass').capitalize() }} ({{ $t('measuringUnits.kg') }})<br />
          {{ roundToFixed2(Number(totalMass)) }}
        </th>
        <th>
          {{ $t('components.scheduleDataTable.totalFootprint') }} ({{ $t('measuringUnits.carbonDioxide') }})<br />
          {{ roundToFixed2(Number(totalFootprint)) }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in items" :key="item.name">
        <td>{{ item.name }}</td>
        <td>{{ roundToFixed2(Number(item.area)) }}</td>
        <td>{{ roundToFixed2(Number(item.volume)) }}</td>
        <td>{{ roundToFixed2(Number(item.mass)) }}</td>
        <td>{{ roundToFixed2(Number(item.footprint)) }}</td>
      </tr>
    </tbody>
  </v-table>
</template>

<style scoped>
@import '@/assets/styles/components/ScheduleDataTable.css';
</style>